import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {SoundManager} from "../resource/sound/SoundManager";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ImmortalFruitsParsedGameData} from "../server/data/ImmortalFruitsParsedGameData";
import {bigWinEvents} from "../views/WinTextView";
import {ReelStop} from "../gameround/reel/ReelStop";
import {ImmortalFruitsSoundConfig} from "../ImmortalFruitsSoundConfig";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";

export class ImmortalFruitsTimelineReelsController extends TimelineReelsController{
    private _nearWinReels: boolean[] = [];
    private _nearBigWinReels: boolean[] = [];
    constructor() {
        super();
    }

    private _scatterPositions : number[] = [];
    private _scatterCounter : number = 0;
    private _wildReelArr : boolean[] = [];
    private _wasFeatureBuy : boolean = false;

    protected addEventListeners(): void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));

    }

    private onGameDataParsed(data: ImmortalFruitsParsedGameData){
        this._scatterCounter = 0;
        this._scatterPositions = data.scatterPositions || [-1,-1,-1,-1,-1];
        this._nearWinReels = data.nearWinReels;
        this._nearBigWinReels = data.nearWinBigWinReels;
        data.evaluatedArea.forEach((symArr, index)=>{
            this._wildReelArr[index] = symArr.indexOf("W") != -1;
        });

        ReelStop.isAnticipationSoundPlayed = false;
        this._wasFeatureBuy = data.wasFeatureBuy;

        //this._bonusWheelTriggered = data.bonusWheelTriggered;
    }
    private playScatterSound(data: IReelStoppedData){
        if(this._scatterPositions[data.reelId] != -1){
            this._scatterCounter++;
            if((data.reelId == 0 && this._scatterCounter == 1) ||
                (data.reelId == 2 && this._scatterCounter == 2) ||
                (data.reelId == 4 && this._scatterCounter == 3)){
                SoundManager.playScatter(this._scatterCounter);
            }
        }
    }

    private playLandingSound(data: IReelStoppedData) {
        if(this._wildReelArr[data.reelId]){
            SoundManager.playWildLanding();
        }
        if (((data.fastSpin || data.quickStop) && (data.reelId === 0 || data.reelId === 2 || data.reelId === 4))) {
            SoundManager.playReelLanding(data.reelId);
        } else if ((!data.fastSpin && !data.quickStop)) {
            SoundManager.playReelLanding(data.reelId);
        }
    }

    protected onReelBounceStarted(stopData: IReelStoppedData): void {
        this.playLandingSound(stopData);
        this.playScatterSound(stopData);
        (this._nearWinReels.indexOf(true) != -1 || this._nearBigWinReels.indexOf(true) != -1) && stopData.reelId == 4 && SoundManager.stopAnticipation();
        !this._wasFeatureBuy && this._nearWinReels[stopData.reelId] && this._scatterCounter < 3 && this._nearBigWinReels.indexOf(true) == -1 && SoundManager.playAnticipationFail();
        stopData.reelId == 4 && SoundManager.stopReelSpinning();
        super.onReelBounceStarted(stopData);
    }

    startSpin(reelId: number): gsap.TimelineLite {
        EventHandler.dispatchEvent(new GameEvent(bigWinEvents.LEVER_YANKING));
        reelId == 0 && SoundManager.playSpinStart(this.getRandomNumber(ImmortalFruitsSoundConfig.instance.SPIN_START_SOUNDS.length -1));
        return super.startSpin(reelId);
    }

    private getRandomNumber(upperLimit : number){
        return Math.round(Math.random() * upperLimit);
    }

    protected onReelSpinStarted(reelId: number): void {
        reelId == 4 && SoundManager.playReelSpinning(this.getRandomNumber(ImmortalFruitsSoundConfig.instance.REELS_SPIN.length -1));
        super.onReelSpinStarted(reelId);
    }
}